import { useEffect, useRef, useState } from "react";

import { createCleaner } from "../../config";
import { useTimeout } from "../../site";
import { Ability } from "./Ability";
import type { TooltipItem } from "./HudController";
import { hud } from "./HudController";

export const Tooltip = () => {
  const detach = useRef<(() => void) | undefined>(undefined);
  const element = useRef<HTMLDivElement | null>(null);
  const timeout = useTimeout();
  const [[show, onEnter], setShow] = useState<[TooltipItem | undefined, (() => void) | undefined]>([undefined, undefined]);

  useEffect(() => {
    const cleaner = createCleaner();

    hud.on("reset", cleaner, () => hud.emit("tooltip"));
    hud.on("tooltip", cleaner, (item, enter) => {
      if(item) {
        setShow([item, enter]);
        timeout.clear();
      } else {
        timeout.set(() => {
          setShow([undefined, undefined]);
          detach.current?.();

          if(element.current) {
            element.current.style.left = "-1000px";
            element.current.style.top = "-1000px";
          }
        }, 10);
      }
    });

    return cleaner.clean;
  }, [timeout]);

  useEffect(() => {
    const engine = document.getElementById("engine");

    if(! engine || ! show || ! element.current) return;

    const { offsetHeight: height, offsetWidth: width } = element.current;
    const handler = ({ x, y }: MouseEvent) => {
      if(! element.current) return;

      const fitLeft = x >= width + 5;
      const fitTop = y >= height + 5;

      element.current.style.left = `${fitLeft ? x - width - 5 : fitTop ? 0 : x + 5}px`;
      element.current.style.top = `${fitTop ? y - height - 5 : fitLeft ? 0 : y + 5}px`;
    };

    engine.addEventListener("mousemove", handler);

    return (detach.current = () => {
      engine.removeEventListener("mousemove", handler);
      detach.current = undefined;
    });
  }, [show]);

  return <div className="panel" id="tooltip" onMouseEnter={onEnter} ref={element}>
    {! show ? null : show.ability ? <Ability ability={show.ability} /> : show.twistCard ? <div className="ability">
      <div style={{ borderBottom: "1px solid #646cff" }}>
        <b>{show.twistCard.name}</b>
      </div>
      {show.twistCard.description}
    </div> : null}
  </div>;
};
